(function () {
  'use strict';

  var BACKEND_HOSTNAME = 'frontend-api.kencko.com';
  var AUTH_SKIP_PREFIX = '/api/v1/auth/';
  var POST_LOGOUT_FLAG = 'kencko-post-logout-redirect';
  var isHandlingAuthError = false;

  // defer guarantees DOM is ready — no DOMContentLoaded listener needed
  var flag = sessionStorage.getItem(POST_LOGOUT_FLAG);
  if (flag === 'true') {
    sessionStorage.removeItem(POST_LOGOUT_FLAG);
    console.debug('[AuthErrorHandler] Post-logout flag detectado, mas user mantém sessão Shopify');
  }

  function isInterceptableBackendUrl(url) {
    // Fast-path: skip URL parsing for requests that clearly aren't backend calls
    if (url.indexOf(BACKEND_HOSTNAME) === -1) return false;
    try {
      var parsed = new URL(url, window.location.href);
      return parsed.hostname === BACKEND_HOSTNAME && parsed.pathname.indexOf(AUTH_SKIP_PREFIX) !== 0;
    } catch (_) {
      return false;
    }
  }

  function handleAuthError() {
    if (isHandlingAuthError) return;
    isHandlingAuthError = true;
    console.warn('[AuthErrorHandler] Backend API retornou 401/403 — user continua autenticado via Shopify');
  }

  var _originalFetch = window.fetch;

  window.fetch = function () {
    var firstArg = arguments[0];
    var url = typeof firstArg === 'string' ? firstArg : (firstArg instanceof Request ? firstArg.url : '');

    return _originalFetch.apply(this, arguments).then(function (response) {
      if ((response.status === 401 || response.status === 403) && isInterceptableBackendUrl(url)) {
        handleAuthError();
      }
      return response;
    });
  };
})();
